import { Badge } from "@/shared/ui/Badge";
import { isRefundDefault } from "../../utils/refundDefault";
import type { LedgerAllocationOperationType } from "../../types/accounting.types";

const RefundDefaultBadge = ({ category }: { category: LedgerAllocationOperationType }) => (
  isRefundDefault(category)
    ? (
      <Badge
        variant="outline"
        className="h-4 shrink-0 whitespace-nowrap px-1 text-[9px] font-medium"
        title="Les remboursements réglés de ce budget sont enregistrés dans cette catégorie"
      >
        Par défaut · remboursements
      </Badge>
    )
    : null
);

export default RefundDefaultBadge;
